import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_status_radiobutton_checked_normal",
  "use": "icon-icon_status_radiobutton_checked_normal-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" overflow=\"visible\" id=\"icon-icon_status_radiobutton_checked_normal\">\n<circle fill=\"#2986FF\" cx=\"10\" cy=\"10\" r=\"7\" />\n<circle fill=\"#FFFFFF\" cx=\"10\" cy=\"10\" r=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol